import axios from "axios";
import { getSessionId } from "../../../../../utils/tokenHandlers";
export const sendBackToFormFilling = (
  customerId: number,
  SendBackComments: string
) => {
  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer/${customerId}`,
      {
        params: {
          context: {},
          data: {
            in_form_filling_comments: `${SendBackComments}`,
            // signed_key_form_status: "Physically Signed",
          },
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((err) => err);
};
